export default {
  mtDataTimePicker: {
    ["年"]: "年",
    ["月"]: "月",
    ["日"]: "日",
    ["时"]: "时",
    ["分"]: "分",
    ["秒"]: "秒"
  }
};
